import { FundingSource, PAGE_TEXT } from '../../../../Nomination/components';
import { type SelectOption } from '../../../../../components';

const fundingSchemaText = PAGE_TEXT.FUNDING_SOURCE.FUNDING_SCHEME.VALUES;

export const distinctiveScholarshipOptions: SelectOption[] = [
  {
    value: FundingSource.POLYU_PRESIDENTIAL_PHD_FELLOWSHIP_SCHEME,
    label: fundingSchemaText.POLYU_PRESIDENTIAL_PHD_FELLOWSHIP_SCHEME,
  },
  {
    value: FundingSource.INTERNATIONAL_PHD_FELLOWSHIP_SCHEME,
    label: fundingSchemaText.INTERNATIONAL_PHD_FELLOWSHIP_SCHEME,
  },
];
